"use client";

import * as React from "react";
import { ArrowRight, CircleCheck, Store } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = ["Hochwertiges Eichenparkett für ein natürliches Standgefühl", "Panoramablick in die unberührte Natur des Soonwalds", "Wohlige Fußbodenheizung für entspanntes Üben", "Lichtdurchflutete Räume für maximale Konzentration"];
export default function RetailSolutions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}